import React from "react"

const PageTitle = props => {
  return <h1>{props.pageHeading}</h1>
}

export default PageTitle
